/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNull } from '../../factoriesAny.js';
export var nullDependencies = {
  createNull: createNull
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNull.generated.js
// module id = 1469
// module chunks = 0